// extracted by mini-css-extract-plugin
export default {"dropdownIcon":"tSuOD","rotated":"LKmWa"};